/* hs-eslint ignored failing-rules */

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../utils/isFlow';
import { getLoginUrl } from '../http-login/getLoginUrl';
import { useTracker } from '../tracking/useTracker';
import { getLoginRedirectUrl } from './getLoginRedirectUrl';
import { StyledUILink } from '../views-components/TextInput.styles';
import { getFlowKey } from '../routing/getFlowKey';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const getHaveAnAccountMessage = () => {
  const flowKey = getFlowKey();
  const messageKey = `button.haveAnAccountMessage.${flowKey}`;
  return isValidI18nKey(messageKey) ? messageKey : 'button.haveAnAccountMessage.default';
};
const getHaveAnAccountI18n = () => {
  return isFlow(Flow.Integrations) ? 'button.haveAnAccountIntegrations' : 'button.haveAnAccount';
};
export const HaveAnAccountLink = () => {
  const Tracker = useTracker();
  const loginRedirectUrl = getLoginRedirectUrl();
  const trackLoginClick = () => {
    Tracker.signupInteraction('click-login-have-an-account', {}, true);
    Tracker.redirect({
      url: `${getFullUrl('app')}/login`
    });
  };
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: getHaveAnAccountI18n(),
    options: {
      link: /*#__PURE__*/_jsx(StyledUILink, {
        "data-selenium": "login",
        href: getLoginUrl({
          redirectUrl: loginRedirectUrl
        }),
        onClick: trackLoginClick,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "button.logIn"
        })
      }, "login-link")
    }
  });
};